import React from 'react'
import { Provider } from 'react-redux'
import { initStore } from './redux/initStore'
import { RegionalEmbed, RegionalEmbedContainer } from './RegionalEmbed'
export { RegionalEmbed } from './RegionalEmbed'

const store = initStore()

export class RegionalEmbedApp extends React.PureComponent {
  static propTypes = RegionalEmbed.propTypes

  render () {
    return (
      <Provider store={store}>
        <RegionalEmbedContainer {...this.props} />
      </Provider>
    )
  }
}
